/**
 * PopulationLegend - Легенда плотности населения
 *
 * Мигрирована на новую систему легенд (Этап 2)
 * Использует LegendRenderer с типом RANGE
 */

import React from 'react';
import { t } from '@lingui/macro';
import { LegendRenderer } from '../../LegendRenderer';
import { POPULATION_LEGEND } from '../../../constants/legends';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';

const PopulationComponent = () => (
    <LegendRenderer config={POPULATION_LEGEND} />
);

export const PopulationLegend = withDisplayedLayersCheck(PopulationComponent, t`Население`);
